import React from 'react'

const Termsconditions = () => {
  return (
   <div className=' '>
        <div className="container">
           <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>
          <img
            src="https://static.wixstatic.com/media/5715af_a286bfb446374a96877a4193a1ef0933~mv2.png"
            alt="PAT Logo"
            style={{ width: '120px', marginRight: '20px', verticalAlign: 'middle' }}
          />
          <img
            src="https://static.wixstatic.com/media/77a25b_ec2fa92086954799bf72699afde7a666~mv2.png"
            alt="VMKG Logo"
            style={{ width: '200px', verticalAlign: 'middle' }}
          />
        </div>
<div
  className="card"
  style={{
    background: "#fff",
    borderRadius: "16px",
    padding: "40px",
    width: "100%",
    maxWidth: "1200px",
    margin: "40px auto",
    boxShadow: "0 6px 30px rgba(0,0,0,0.1)",
    fontSize: "16px",
    color: "#333",
    lineHeight: "1.7",
    textAlign: "left",
    overflowY: "auto",
    maxHeight: "100%",
    position: "relative"
  }}
>
  {/* Heading */}
  <h2
    style={{
      fontSize: "30px",
      fontWeight: "700",
      marginBottom: "20px",
      textAlign: "center",
      color: "#222"
    }}
  >
    Terms & Conditions
  </h2>

  {/* Intro paragraph */}
  <p style={{ marginBottom: "20px", color: "#555", fontSize: "17px" }}>
    Welcome to Personal Assessment Test, an online platform by Victor Manickam
    Knowledge Group, legally known as Humandesign Education Pvt Ltd dedicated
    to guiding individuals from Ignorance to Awareness. By accessing or using
    our services, you agree to the following terms and conditions:
  </p>

  {/* Ordered sections */}
  <ol style={{ paddingLeft: "22px", marginTop: "10px" }}>
    <li style={{ marginBottom: "18px" }}>
      <strong>Purpose of Assessments:</strong>
      <ul style={{ marginTop: "6px", paddingLeft: "20px", listStyleType: "disc" }}>
        <li>
          Our assessments aim to assist individuals in becoming self-aware by
          providing insights into critical aspects of life.
        </li>
        <li>
          The Personal Assessment Test offers a comprehensive evaluation to
          understand one's personality and explore possibilities beyond current
          definitions.
        </li>
      </ul>
    </li>

    <li style={{ marginBottom: "18px" }}>
      <strong>Comprehensive Assessment Report:</strong>
      <ul style={{ marginTop: "6px", paddingLeft: "20px", listStyleType: "disc" }}>
        <li>Upon completion of the Personal Assessment Test, users will receive a detailed 17-page report.</li>
        <li>
          The report includes a personalized letter, wheel of life scores with explanations, an overview report, and an appendix detailing each section.
        </li>
      </ul>
    </li>

    <li style={{ marginBottom: "18px" }}>
      <strong>Diagnostic Report:</strong>
      <ul style={{ marginTop: "6px", paddingLeft: "20px", listStyleType: "disc" }}>
        <li>
          The assessment is designed to offer a 25-minute diagnostic report empowering individuals to understand themselves in depth.
        </li>
        <li>
          It focuses on analysing five fundamental areas: Relationships, Health, Wealth, Work/Education, and Self-Awareness.
        </li>
      </ul>
    </li>

    <li style={{ marginBottom: "18px" }}>
      <strong>Scoring Model:</strong>
      <ul style={{ marginTop: "6px", paddingLeft: "20px", listStyleType: "disc" }}>
        <li>Scores in the report are based on a bell curve model, not a linear scale.</li>
        <li>
          Scores from 0 to 1 represent two ends of a spectrum, with the peak of the bell curve between 0.5-0.7, ascending from 0-0.4, and descending from 0.7-1.
        </li>
        <li>
          This scoring method is chosen to align with the wave theory, reflecting the natural ebb and flow of life.
        </li>
      </ul>
    </li>

    <li style={{ marginBottom: "18px" }}>
      <strong>Accuracy and Reliability:</strong>
      <ul style={{ marginTop: "6px", paddingLeft: "20px", listStyleType: "disc" }}>
        <li>The assessment reports have an accuracy range of 80% - 90% in at least 9 out of 10 cases.</li>
        <li>They are validated across different age groups to ensure reliability.</li>
      </ul>
    </li>

    <li style={{ marginBottom: "18px" }}>
      <strong>Confidentiality:</strong>
      <ul style={{ marginTop: "6px", paddingLeft: "20px", listStyleType: "disc" }}>
        <li>
          All reports are automatically generated using state-of-the-art backend software, maintaining the confidentiality of user data.
        </li>
        <li>
          Data and scoring patterns are analysed to enhance our tools and keep reports relevant and updated.
        </li>
      </ul>
    </li>

    <li style={{ marginBottom: "18px" }}>
      <strong>Authenticity of Responses:</strong>
      <ul style={{ marginTop: "6px", paddingLeft: "20px", listStyleType: "disc" }}>
        <li>Users are encouraged to provide authentic and relevant responses during the assessment.</li>
        <li>Taking the test in a single sitting of 20-30 minutes is recommended for optimal results.</li>
      </ul>
    </li>

    <li style={{ marginBottom: "18px" }}>
      <strong>Test Recommendations:</strong>
      <ul style={{ marginTop: "6px", paddingLeft: "20px", listStyleType: "disc" }}>
        <li>If the report seems unconvincing, users are advised to retake the test.</li>
        <li>It is recommended to take the Personal Assessment Test every 3-4 months for a comprehensive life check-up.</li>
      </ul>
    </li>

    <li style={{ marginBottom: "18px" }}>
      <strong>Continuous Development:</strong>
      <ul style={{ marginTop: "6px", paddingLeft: "20px", listStyleType: "disc" }}>
        <li>
          The test and its reports are continuously evolving.
        </li>
        <li>
          Updates and newer versions may render older versions obsolete without prior notice.
        </li>
        <li>
          However, individual data will always be accessible.
        </li>
      </ul>
    </li>

    <li style={{ marginBottom: "18px" }}>
      <strong>Acceptance of Terms:</strong>
      <ul style={{ marginTop: "6px", paddingLeft: "20px", listStyleType: "disc" }}>
        <li>
          By using Personal Assessment Test, you acknowledge and agree to these terms and conditions.
        </li>
        <li>
          These terms may be updated or modified, and it is recommended to review them periodically.
        </li>
   
      </ul>
    </li>
  </ol>
  <p style={{ marginBottom: "20px", color: "#555", fontSize: "17px" }}>
  If you have any questions or concerns about these terms and conditions, please contact us at <span style={{ color: "#2369A6" }}>reachus@victormanickam.com</span> Thank you for choosing Personal Assessment Test for your journey towards self-awareness.
  </p>
  {/* Sticky footer button */}
  <div
    style={{
      position: "sticky",
      bottom: "0",
      background: "#fff",
      padding: "20px 0",
      textAlign: "center",
      borderTop: "1px solid #eee",
      marginTop: "20px"
    }}
  >
    {/* Uncomment if you want action button */}
    {/* <button
      style={{
        background: "#396AA9",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        padding: "12px 28px",
        fontSize: "16px",
        fontWeight: "600",
        cursor: "pointer",
        transition: "0.3s"
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#FEBD16")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "#396AA9")}
    >
      Accept & Proceed
    </button> */}
  </div>
</div>





    
    </div>
    </div>
  )
}

export default Termsconditions